import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

export const showConfirm = (title, message, onConfirm) => {
    confirmAlert({
        title: title,
        message: message,
        buttons: [
            {
                label: 'Yes, Delete',
                onClick: onConfirm,
                className: 'confirm-btn-yes'
            },
            {
                label: 'Cancel',
                className: 'confirm-btn-no'
            }
        ],
        closeOnEscape: true,
        closeOnClickOutside: true,
    });
};
